import ApplicationPortal from 'state/enums/ApplicationPortal'
import getPortal from 'utils/getPortal'

export const CAPTIVE_PORTALS: ReadonlySet<ApplicationPortal> = new Set([
    ApplicationPortal.BUFFALO,
    ApplicationPortal.FOREST_RIVER,
])

export default function getCaptiveIdentifier(): ApplicationPortal | undefined {
    const portal = getPortal()

    return CAPTIVE_PORTALS.has(portal) ? portal : undefined
}
